import * as actionTypes from '../actions/actionTypes';

const initState = {
  loading: false,
  users: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USERS_START:
      return { ...state, loading: true };
    case actionTypes.FETCH_USERS_END:
      const { users } = action;
      return { ...state, loading: false, users };
    default:
      return state;
  }
};

export const parse = users => {
  if (!users) return null;
  return users.map(e => {
    if (e['platform'] === 'UNKNOWN') e['platform'] = 'unavailable';
    if (e.name.length > 0 && e.company.length > 0) {
      e['type'] = 'Contractor';
      e['phone_no'] = e['phone_no'].length > 0 ? e['phone_no'] : 'unavailable';
    } else {
      e['type'] = 'Homeowner';
      e['name'] = 'unavailable';
      e['company'] = 'unavailable';
      e['phone_no'] = 'unavailable';
    }
    return e;
  });
};

export const parseExcel = users => {
  if (!users) return null;
  return users.map(e => {
    if (e['platform'] === 'UNKNOWN') e['platform'] = 'unavailable';
    if (e.name.length > 0 && e.company.length > 0) {
      if (e['role'] === '1') {
        e['type'] = 'Staff';
      } else {
        e['type'] = 'Contractor';
      }
    } else {
      e['type'] = 'Homeowner';
      e['name'] = 'unavailable';
      e['company'] = 'unavailable';
      e['phone_no'] = 'unavailable';
    }

    return {
      type: e.type,
      company: e.company,
      name: e.name,
      phone: e.phone_no,
    };
  });
};



// WEBPACK FOOTER //
// ./src/store/reducers/user.js